// import { db } from '../firebase'
import { getStorage, ref, uploadBytes, getDownloadURL } from 'firebase/storage';

export const initialValues = {
  username: '',
  type: '',
  days: undefined,
  bicycle: undefined,
  price: undefined,
  image: undefined
};

export const items = Array(5)
  .fill()
  .map((v, i) => {
    return { title: '' };
  });

export const types = ['Crédito', 'Débito', 'General'];

export const validateEmpty = (value) => {
  let error;
  if (!value) {
    error = `Required field`;
    return error;
  }
};

export const maxDays = Array(51)
  .fill()
  .map((v, i) => i);

export const eurosDE = Intl.NumberFormat('de-DE', {
  style: 'currency',
  currency: 'EUR',
  currencyDisplay: 'symbol'
});

const uploadImgFirebase = async ({ img, path }) => {
  const storage = getStorage();
  const filename = img.substring(img.lastIndexOf('/') + 1);
  const storageRef = ref(storage, `${path}/${filename}`);

  const blob = await new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.onload = function () {
      resolve(xhr.response);
    };
    xhr.onerror = function () {
      reject(new TypeError('Network request failed'));
    };
    xhr.responseType = 'blob';
    xhr.open('GET', img.url, true);
    xhr.send(null);
  });
  let urlImg;
  await uploadBytes(storageRef, blob).then(async () => {});
  await getDownloadURL(storageRef)
    .then((url) => {
      urlImg = url;
    })
    .catch((error) => {
      // Handle any errors
    });
  return urlImg;
};

export const uploadImages = async (img, path) => {
  const imagesUrl = [];
  let data = { img, path };
  const res = await uploadImgFirebase(data);
  if (res) {
    imagesUrl.push(res);
  }

  return imagesUrl;
};

export const mywords = [
  'creditos',
  'banca',
  'debitos',
  'sifone',
  'prestamos',
  'confianza',
  'seguridad',
  'ahorro',
  'seguro',
  'online',
  'app',
  'corriente',
  'cuenta',
  'app',
  'sifone',
  'tdc',
  'tarjeta',
  'normal',
  'agil',
  'rapidez',
  'seguro',
  'app',
  'creditos',
  'banca',
  'debitos',
  'sifone',
  'prestamos',
  'confianza',
  'seguridad',
  'ahorro',
  'seguro',
  'online',
  'app',
  'corriente',
  'cuenta',
  'app',
  'sifone',
  'tdc',
  'tarjeta',
  'normal',
  'agil',
  'rapidez',
  'seguro',
  'app'
];
